import { buildSlice, CommonState } from '~libs/reduxUtils';

import { Classification } from '~support-at-home/models';

import { getAll, typePrefix } from '~support-at-home/actions/classifications';

const initialState: CommonState<Classification> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  grouped: [],
};

const slice = buildSlice<CommonState<Classification>, Classification>(typePrefix, initialState, {
  customActions: {
    clear(state) {
      state.rows = [];
    },
    clearError(state) {
      state.error = null;
    },
  },
  commonConfig: { getAll },
});

export const { clear, clearError } = slice.actions;
export default slice.reducer;
